<template>
	<div class="AppLayout">
		<div class="main">
			<!-- <app-nav-bar /> -->
			<!-- <el-row>
        <el-col
          :xs="24"
          :sm="24"
          :md="5"
          :lg="5"
          :xl="5"
        > -->
			<div v-if="isBK">
				<AppSideBarV2BK />
			</div>
			<div v-else-if="isMCD">
				<AppSideBarV2MCD />
			</div>
			<div v-else>
				<app-side-bar-v2 />
			</div>
			<!-- <app-side-bar /> -->
			<!-- </el-col>
        <el-col
          :xs="24"
          :sm="24"
          :md="19"
          :lg="19"
          :xl="19"
        > -->
			<div class="main__content">
				<app-nav-bar-v2 />
				<!-- <app-sales-performance class="sales-performance-card" /> -->
				<div class="main__content--items">
					<!-- <AccountSetupV2 /> -->
					<router-view />

					<!-- <app-sales-tab />
        <app-forecast />
        <app-category-bar />
        <app-table />
        <app-pie-chart />
        <app-wow-graph />
        <app-product-launch />
        <MarketingEvent />
        <AppSalesPerformanceCard /> -->
		<!-- Download loading prompt -->
		<DownloadLoadingPrompt></DownloadLoadingPrompt>
						<!-- Process running notifier for store settings page save button -->
						<process-running-notifier></process-running-notifier>
				</div>
			</div>
			<!-- </el-col>
      </el-row> -->
		</div>
	</div>
</template>
<script>
import AppSideBarV2 from "./appSideBarV2/appSideBarV2";
import AppSideBarV2BK from "./appSideBarV2/appSideBarV2BK.vue";
import AppSideBarV2MCD from "./appSideBarV2/appSideBarV2MCD.vue";
import AppNavBarV2 from "./appNavBarV2/AppNavBarV2";
// import AppSalesDropdown from "./appSalesDropdown/AppSalesDropdown";
// import AccountSetupV2 from "../accountSetupV2/AccountSetupV2.vue";
import DownloadLoadingPrompt from "./DownloadLoadingPrompt";
import { mapState } from "vuex";
import ProcessRunningNotifier from "../shared/ProcessRunningNotifier.vue";
// import AppSalesPerformance from "./appSalesPerformanceCard/AppSalesPerformanceCard.vue";
export default {
	components: {
		AppSideBarV2,
		AppNavBarV2,
		DownloadLoadingPrompt,
		AppSideBarV2BK,
		AppSideBarV2MCD,
		// AppSalesPerformance,
		// AccountSetupV2,
		ProcessRunningNotifier,
	},
	data() {
		return {
			// isSideBarWidthMin: true,
			// isSideBarWidthMax: false
		};
	},
	computed: {
		...mapState("CommonStore", ["companyData"]),
		isBK(){
			let data = false;
			if(Object.keys(this.companyData).length) {
				data = this.companyData.check_company.is_bk;
			} else {
				const company_id = localStorage.getItem('company_id');
				data = company_id === '5bfb5014-8af3-4980-90fa-5d19dcad4679';
			}
			return data;
		},
		isMCD(){
			let data = false;
			if(Object.keys(this.companyData).length) {
				data = this.companyData.check_company.is_mcd;
			} else {
				const company_id = localStorage.getItem('company_id');
				data = company_id === '2b712b21-ed49-469d-856b-1f0c87fac4be';
			}
			return data;
		}
	},
	created() {},
	mounted() {
		document.getElementById("app").style.marginLeft = "60px";
		// document.getElementById("app").style.transition = "0.5s";
		// console.log("route name", this.$route);
	},
	methods: {
		// mouseOverFn() {
		// 	if (this.isSideBarWidthMin) {
		// 		this.$refs["app-side-bar"].style.width = "312px";
		// 		this.isSideBarWidthMax = true;
		// 		return;
		// 	}
		// },
		// mouseOutFn() {
		// 	if (this.isSideBarWidthMax) {
		// 		this.$refs["app-side-bar"].style.width = "70px";
		// 		this.isSideBarWidthMin = true;
		// 		return;
		// 	}
		// }
	}
};
</script>
<style lang="scss" scoped>
.AppLayout {
	background: #f8f8f8;
	min-height: 100vh;
	overflow: hidden;
}
.AppLayout .main {
	display: flex;
}
.AppLayout .app-side-bar {
	// width: 70px;
	// overflow-x: hidden;
	// height: 1600px;
}
.AppLayout .main__content {
	min-width: calc(100% - 17rem);
	flex-grow: 1;
	flex-basis: auto;
	// margin-left: 60px;
	// box-sizing: border-box;
	// padding: 0.5rem 1rem;
}
.AppLayout .main__content--items {
	padding: 0 1rem 1rem;
}
.AppLayout .main__content .sales-performance-card {
	padding: 0 1rem 1rem 1rem;
}
@media screen and (max-width: 650px) {
	.AppLayout {
		height: 100%;
	}
}
</style>
